import router from '@/router/index'

// 路由跳转
export default function routerJump(path: string):void {
  router.push(path);
}
